'use client';

import Image from 'next/image';

import { tw } from '../../utils';

interface TileImageProps {
  src: string;
  alt: string;
  hasFooter?: boolean;
}

export const TileImage: React.FC<TileImageProps> = ({
  src,
  alt,
  hasFooter,
}: TileImageProps) => {
  return (
    <Image
      src={src}
      alt={alt}
      fill
      className={tw(
        'max-h-full max-w-full overflow-hidden',
        hasFooter ? 'rounded-t-[15px]' : 'rounded-[15px]',
      )}
      sizes='150px'
    />
  );
};
